import { useCallback } from 'react';
import Icon from '../../Atoms/Icon/Icon';
import snakeToCamelCase from '../../../utils/snakeToCamelCase';
import bem from '../../../utils/bem';
import useWindowWidth from '../../../hooks/useWindowWidth';

const Modal = (props) => {
  const { breakpoint } = useWindowWidth();
  const {
    children,
    modalId,
    modalModifiers = [],
    widthSmall,
    centered,
    variantClassic,
    modalExtra = [],
  } = snakeToCamelCase(props);

  const modalClasses = useCallback(
    bem(
      'modal',
      [
        ...modalModifiers,
        widthSmall ? 'small' : '',
        centered ? 'text-center' : '',
        variantClassic ? 'variant-classic' : '',
      ],
      '',
      ['js-modal', 'hidden', ...modalExtra],
    ),
    [modalModifiers, widthSmall, centered, variantClassic, modalExtra],
  );

  const showSmallIcon =
    (!widthSmall || breakpoint.isMobile) && !breakpoint.isDesktop;

  const closeBtn = (
    <button
      title={Drupal.t('Close')}
      className={bem(
        'btn-icon',
        ['close', showSmallIcon ? 'close-small' : ''],
        '',
        ['js-modal-close'],
      )}
      onClick={props?.onCloseHandler}
    >
      {showSmallIcon ? (
        <Icon iconName="close-small" />
      ) : (
        <Icon iconName="close" />
      )}
    </button>
  );

  return (
    <div className={modalClasses} data-modal-id={modalId}>
      <div className="container">
        {children}
        {widthSmall && closeBtn}
      </div>
      {!widthSmall && closeBtn}
    </div>
  );
};

export default Modal;
